/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./button.vue?vue&type=template&id=41e7823e&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"
import style0 from "./button.vue?vue&type=style&index=0&id=41e7823e&prod&lang=scss"
import style1 from "./button.vue?vue&type=style&index=1&id=41e7823e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e7823e",
  null
  
)

export default component.exports